import { Col, Form, Row } from "react-bootstrap";

const FormSenderAddress = ({ senderAddress, haghighi, hoghooghi }) => {
  return (
    <div key={senderAddress.id}>
      <Row>
        <Col lg={2} md={2} sm={6} xs={12}>
          <Form.Label>
            نوع: <span className="text-danger">*</span>
          </Form.Label>
          <Form.Select
            className="select"
            name="type"
            defaultValue={senderAddress.type}
            disabled
          >
            <option value="0">حقیقی</option>
            <option value="1">حقوقی</option>
          </Form.Select>
        </Col>
        {haghighi ? (
          <Col lg={5} md={5} sm={6} xs={12}>
            <Form.Label>
              نام:<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              defaultValue={senderAddress.name}
              disabled
            />
          </Col>
        ) : null}

        {haghighi ? (
          <Col lg={5} md={5} sm={6} xs={12}>
            <Form.Label>
              نام خانوادگی:
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              defaultValue={senderAddress.family}
              disabled
            />
          </Col>
        ) : null}

        {hoghooghi ? (
          <Col lg={5} md={5} sm={6} xs={12}>
            <Form.Label>
              نام شرکت:<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              defaultValue={senderAddress.compony}
              disabled
            />
          </Col>
        ) : null}

        {hoghooghi ? (
          <Col lg={5} md={5} sm={6} xs={12}>
            <Form.Label>
              شناسه ملی: <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="shenase"
              defaultValue={senderAddress.shenase}
            />
          </Col>
        ) : null}
      </Row>
      <Row>
        {haghighi ? (
          <Col>
            <Form.Label>
              کدملی:<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              defaultValue={senderAddress.irCode}
              disabled
            />
          </Col>
        ) : null}
        <Col>
          <Form.Label>
            موبایل:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.mobile}
            disabled
          />
        </Col>
        <Col>
          <Form.Label> تلفن:</Form.Label>
          <Form.Control type="text" defaultValue={senderAddress.tel} disabled />
        </Col>
      </Row>

      <Row>
        <Col xl={3} lg={3} md={6} sm={12} xs={12}>
          <Form.Label>
            استان:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.province}
            disabled
          />
        </Col>

        <Col xl={3} lg={3} md={6} sm={12} xs={12}>
          <Form.Label>
            شهر:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.city}
            disabled
          />
        </Col>

        <Col xl={3} lg={3} md={6} sm={12} xs={12}>
          <Form.Label>
            منطقه:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.area}
            disabled
          />
        </Col>

        <Col xl={3} lg={3} md={6} sm={12} xs={12}>
          <Form.Label> کد پستی: </Form.Label>
          <Form.Control
            type="text"
            defaultValue={senderAddress.postCode}
            disabled
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <Form.Label>
            آدرس:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            defaultValue={senderAddress.address}
            disabled
          />

          <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
        </Col>
      </Row>
    </div>
  );
};

export default FormSenderAddress;
